goog.provide("shadow.js.shim.module$dayjs$locale$zh_cn");
goog.provide("module$shadow_js_shim_module$dayjs$locale$zh_cn");
shadow.js.shim.module$dayjs$locale$zh_cn = shadow.js.nativeProvides["dayjs/locale/zh-cn"] = require("dayjs/locale/zh-cn");
module$shadow_js_shim_module$dayjs$locale$zh_cn.default = shadow.js.shim.module$dayjs$locale$zh_cn;
